// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"850032ba","229":"a72ceced","244":"58042621","354":"475d015f","863":"c09969e2"}[chunkId] + ".chunk.css";
};